class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.locksBodyScroll = false;

    if (!this.detailsContainer || !this.summaryToggle) return;

    this.detailsContainer.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.close();
    });
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]')?.addEventListener('click', this.close.bind(this));
    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return Boolean(this.detailsContainer?.hasAttribute('open'));
  }

  onSummaryClick(event) {
    if (!this.detailsContainer || !this.summaryToggle) return;
    event.preventDefault();
    this.detailsContainer.hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList?.contains('modal-overlay')) this.close(false);
  }

  open(event) {
    if (!this.detailsContainer || !this.summaryToggle) return;

    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);

    /* Header search is a sticky dropdown, not a full-screen modal. Locking body here
       caused the page to freeze/jump when Search was opened after scrolling. */
    this.locksBodyScroll = !this.classList.contains('header__search');
    if (this.locksBodyScroll) document.body.classList.add('overflow-hidden');

    const focusContainer = this.detailsContainer.querySelector('[tabindex="-1"]') || this.detailsContainer;
    const initialFocus = this.detailsContainer.querySelector('input:not([type="hidden"])') || this.summaryToggle;
    trapFocus(focusContainer, initialFocus);
  }

  close(focusToggle = true) {
    if (!this.detailsContainer) return;
    removeTrapFocus(focusToggle && this.summaryToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    if (this.onBodyClickEvent) document.body.removeEventListener('click', this.onBodyClickEvent);
    if (this.locksBodyScroll) document.body.classList.remove('overflow-hidden');
    this.locksBodyScroll = false;
  }
}

if (!customElements.get('details-modal')) customElements.define('details-modal', DetailsModal);
